// Types
import {amount as amountType} from '@drivesally/sally-fn/lib/types';

export const raw = ({rental: {drivers = []} = {}} = {}) =>
  [...drivers].reduce((sum, {driver}) => driver.deposit + sum, 0);

export default (args) => `$${amountType(raw(args)).format()}`;
